import { IEntity } from "@interfaces/entity"

export class StripeInfo implements IEntity {
  id: number
  
  userId: string

  stripeSubscriptionId: string
  stripeCustomerId: string
  stripeAccountId: string
  stripeOnboardingUrl: string
  stripeProductId: string

  entityName = "StripeInfo"

  constructor(formValue?: Partial<StripeInfo>) {
    Object.assign(this, formValue)
  }

  updateValues(formValue: Partial<StripeInfo>) {
    Object.assign(this, formValue)
  }

  getPrimaryKey() {
    return this.id
  }
}
